import {DivIcon, MarkerCluster, Point} from "leaflet";
import {getPointIconMergeSingleVoyage} from "@containers/singleVoyage/containers/points/helpers/icons";
import {
    getPointsByMarkersCustomPropertySingleVoyage
} from "@containers/singleVoyage/containers/points/helpers/getPointsByMarkersCustomProperty";
import {
    buildPointIconSingleVoyageHtmlSingleVoyage,
    buildPointIconSingleVoyageNameSingleVoyage
} from "@containers/singleVoyage/containers/points/icon/buildPointIcon";


const defaultBuildPointClusterIcon = ({childCount}: { childCount: number }) => {

    let c = ' marker-cluster-';
    if (childCount < 10) {
        c += 'small';
    } else if (childCount < 100) {
        c += 'medium';
    } else {
        c += 'large';
    }

    return new DivIcon({
            html: `<div style="width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;border-radius: 50%"><span style="color:white;white-space: nowrap;"> ${childCount} <span aria-label="markers"></span></span></div>`,
            className: 'marker-cluster' + c,
            iconSize: new Point(50, 50)
        }
    );
}

const getPointWidth = (childCount: number) => {
    if (childCount > 1) {
        return 60
    }
    return 30

}
const getPointHeight = (childCount: number) => {
    if (childCount > 2) {
        return 45
    }
    return 30

}

function defaultCreateFunctionPointIcon(cluster: MarkerCluster) {
    const childCount = cluster.getChildCount();
    return defaultBuildPointClusterIcon({childCount})
}

const buildHtml = ({
                       cluster,
                   }: {
    cluster: MarkerCluster,
}): {
    height: number,
    html: string
} => {
    const children = cluster.getAllChildMarkers();

    let pointsStr = ''

    const points = getPointsByMarkersCustomPropertySingleVoyage(children)
    const sortedPoints = points.sort((a, b) => a.number - b.number)

    sortedPoints.forEach((point, index) => {
        pointsStr += `<div class="pointClusterList-item-${index + 1}">${buildPointIconSingleVoyageHtmlSingleVoyage({number: point.number})}</div>`
    })
    const firstPoint = sortedPoints[0]
    const name = buildPointIconSingleVoyageNameSingleVoyage(firstPoint?.name)

    const width = getPointWidth(children.length);
    const height = getPointHeight(children.length);

    const html = `<div class="pointClusterRoot">
                 <div class="pointClusterName">${name}</div>
                
                <div style="width: ${width}px;height: ${height}px" class="pointClusterList pointClusterList-${children.length}">
                      ${pointsStr}
                    <div style="width:${width}px;height: ${height}px" class="pointClusterListIcon">
                        ${getPointIconMergeSingleVoyage(children.length)}
                     </div>
                  </div>
                </div>`
    return {
        html,
        height
    }
}


const multiCreateFunctionPointsIcon = ({
                                           cluster,
                                       }: {
    cluster: MarkerCluster,
}) => {

    const {height, html} = buildHtml({
        cluster,
    })

    return new DivIcon({
            html,
            iconSize: [95, height + 22]
        }
    );

}

export function clusterPointsGroupCreateFunctionSingleVoyage({
                                                     cluster,
                                                 }: {
    cluster: MarkerCluster,
}) {
    const childCount = cluster.getChildCount();
    if (childCount >= 4) {
        return defaultCreateFunctionPointIcon(cluster)
    }
    return multiCreateFunctionPointsIcon({
        cluster,
    })


}